<template>
  <nav class="header__nav">
    <button id="close" class="close-btn btn-reset">
      <svg>
        <use xlink:href="#close-icon"></use>
      </svg>
    </button>
    <ul class="header__nav-list list-reset">
      <li class="header__nav-item" v-for="link in links" :key="link.title">
        <router-link
          :to="{ name: link.page, hash: link.hash }"
          :class="[mainPage ? '' : '__black']"
          class="header__nav-link link-reset"
        >
          {{ link.title }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.header__nav {
  margin-left: auto;
}
.close-btn {
  display: none;
  width: 30px;
  height: 30px;
  margin-bottom: 30px;
}

.close-btn svg {
  width: 100%;
  height: 100%;
  fill: var(--white);
}

.header__nav-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
}

.header__nav-item:not(:last-child) {
  margin-right: 20px;
}

.header__nav-link {
  font-size: 14px;
  line-height: 100%;
  font-weight: 500;
  transition: color 0.2s linear;
  color: var(--white);
}

.header__nav-link:hover:not(:active) {
  color: var(--main);
}

.header__nav-link:active {
  color: var(--main-active);
}

.header__nav-link:focus-visible:not(:active) {
  color: var(--main-hover);
}

.__black {
  color: var(--black);
}

.__black:hover:not(:active) {
  color: rgb(90, 90, 90);
}

.__black:active {
  color: #666;
}

.__black:focus-visible:not(:active) {
  color: #555;
}

@media (max-width: 1160px) {
  .header__nav-item {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    width: 30%;
    text-align: center;
  }
}

@media (max-width: 960px) {
  .header__nav-list {
    justify-content: flex-end;
  }

  .header__nav-item:not(:last-child) {
    margin-right: 0;
  }
}

@media (max-width: 769px) {
  .close-btn {
    display: block;
  }

  .header__nav {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 15px 25px;
    transform: translateX(-100%);
    z-index: 100;
    background-color: rgb(0, 0, 0, 0.9);
    overflow: hidden;
    transition: transform 0.2s linear;
  }

  .header__nav-list {
    flex-direction: column;
  }

  .header__nav-item {
    width: auto;
  }

  .header__nav-item:last-child {
    margin-bottom: 0;
  }

  .header__nav-item:not(:last-child) {
    margin-right: 0;
    margin-bottom: 25px;
  }

  .header__nav-link {
    font-size: 0.9em;
  }

  .__black {
    color: var(--white);
  }
}
</style>

<script>
export default {
  data () {
    return {
      links: [
        {
          title: 'О нас',
          page: 'main',
          hash: '#about'
        },
        {
          title: 'Суть программы',
          page: 'main',
          hash: '#desc'
        },
        {
          title: 'Преимущества',
          page: 'main',
          hash: '#advantage'
        },
        {
          title: 'Материалы',
          page: 'main',
          hash: '#materials'
        },
        {
          title: 'Калькулятор',
          page: 'main',
          hash: '#calculator'
        },
        {
          title: 'Регистрация',
          page: 'register',
          hash: ''
        },
        {
          title: 'Личный кабинет',
          page: 'personal',
          hash: ''
        }
      ]
    }
  },
  props: ['mainPage']
}
</script>
